import React, { useContext, useMemo } from "react";
import { trpc } from "../../../utils/trpc";
import { PublicationContext } from "../WithPublication/PublicationContext";
import { BookmarkContext } from "./BookmarkContext";

export const BookmarkProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { publication } = useContext(PublicationContext);

  const { data } = trpc.getBookmarksByPublication.useQuery(
    { publicationId: publication?.id },
    { enabled: !!publication?.id },
  );

  const value = useMemo(() => {
    return {
      bookmarksByPublication: data,
    };
  }, [data]);

  return (
    <BookmarkContext.Provider value={value}>
      {children}
    </BookmarkContext.Provider>
  );
};
